import { cn } from "helpers/classNames";
import { FC } from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const ModalContentWrapper: FC<Props> = ({ children, className }) => (
  <div className={cn("mt-8 space-y-8", className)}>{children}</div>
);
